const addRecentlyViewed = () => {
  const productHandle = window.location.pathname.match(/\/products\/([a-zA-Z0-9\-]+)/);
  if (!productHandle || !productHandle[1]) return;
  const handle = productHandle[1];

  let viewed = [];
  try {
    const raw = localStorage.getItem('shopify_recently_viewed');
    viewed = raw ? JSON.parse(raw) : [];
  } catch (e) {
    console.warn('Could not read recently viewed from localStorage:', e);
    return;
  }

  if (viewed.includes(handle)) {
    viewed = viewed.filter(h => h !== handle);
  }
  
  viewed.unshift(handle);
  if (viewed.length > 5) {
    viewed = viewed.slice(0, 5);
  }
  
  try {
    localStorage.setItem('shopify_recently_viewed', JSON.stringify(viewed));
  } catch (e) {
    console.warn('Could not save recently viewed to localStorage:', e);
  }
};

const renderRecentlyViewed = () => {
  const container = document.querySelector('[data-recently-viewed-container]');
  if (!container) return;

  let viewed = [];
  try {
    const raw = localStorage.getItem('shopify_recently_viewed');
    viewed = raw ? JSON.parse(raw) : [];
  } catch (e) {
    console.warn('Could not read recently viewed from localStorage:', e);
    return;
  }

  const currentProductHandle = window.location.pathname.match(/\/products\/([a-zA-Z0-9\-]+)/);
  if (currentProductHandle && currentProductHandle[1]) {
    viewed = viewed.filter(h => h !== currentProductHandle[1]);
  }

  if (viewed.length === 0) {
    return;
  }

  const section = container.closest('.recently-viewed-section');
  if (section) section.style.display = 'block';

  let queries = viewed.map(handle =>
    fetch(`/products/${handle}?view=card`)
      .then(res => res.ok ? res.text() : '')
      .catch(() => '')
  );
  
  Promise.all(queries).then(htmlArray => {
    const validCards = htmlArray.filter(html => html && html.trim().length > 0);
    if (validCards.length > 0) {
      container.innerHTML = `<ul class="grid product-grid grid--4-col-desktop grid--2-col-tablet-down">
        ${validCards.map(html => `<li class="grid__item">${html}</li>`).join('')}
      </ul>`;
    }
  }).catch(err => {
    container.innerHTML = '';
  });
};

document.addEventListener('DOMContentLoaded', () => {
  addRecentlyViewed();
  renderRecentlyViewed();
});
